
import Http from './Http'

export default {
    async getNews(limit = 1000, lang= '',show_deleted = '') {
        return await Http.get(`/content/news?limit=${limit}&lang=${lang}&show_deleted=${show_deleted}`);
    },
    async getNewsLanguage() {
        return await Http.get(`/content/news/lang`)
    },
    async removeNews(id) {
        return await Http.delete(`/content/news?source_id=${id}`)
    },
    async restoreNews(id) {
        return await Http.delete(`/content/restoreNews?source_id=${id}`)
    },
    async restoreVideo(id) {
        return await Http.delete(`/content/restoreVideos/${id}`)
    },
    async restoreShort(id) {
        return await Http.delete(`/content/restoreShorts/${id}`)
    },
    async getVideos(limit = 1000,show_deleted = 1) {
        return await Http.get(`/content/videos?limit=${limit}&show_deleted=${show_deleted}&all`)
    },
    async getShorts(limit = 10){
        return await Http.get(`/content/shorts?show_deleted=1&limit=${limit}`)
    },
    async removeShorts(id){
       return await Http.delete(`/content/shorts/${id}`)
    },
    async removeVideos(id) {
        return await Http.delete(`/content/videos/${id}`)
    },
    async fireEvent(data) {
        return await Http.post(`/content/fireEvent`, data)
    },
    async addBusinessNews(data) {
        return await Http.post(`/business/news`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async getBusinessNews(limit = 1000,active = 'all',content_type, event_status='all', show_deleted = '') {
        return await Http.get(`/business/news?limit=${limit}&active=${active}&content_type=${content_type}&event_status=${event_status}&show_deleted=${show_deleted}`)
    },
    async getSingleBusinessNews(news_id,content_type) {
        return await Http.get(`/business/news?content_type=${content_type}&event_id=${news_id}`)
    },
    async deleteBusinessNews(news_id) {
        return await Http.delete(`/business/news/${news_id}`)
    },
    async restoreBusinessNews(source_id) {
        return await Http.delete(`/business/restoreNews?source_id=${source_id}`)
    },
    async editBusinessNews(news_id, data){
        return await Http.post(`/business/news/${news_id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async getNewsFeed(lang= ''){
        return await Http.get(`/content/feed?lang=${lang}`)
    },
    async updateFeed(id, data){
        return await Http.post(`/content/feed/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })

    },
    async getBusinessEventmembers(event_id){
        return await Http.get(`/business/event/${event_id}/members/export`)
    },
    async getBusinessEventFieldsDefinition(){
        return await Http.get(`/business/event/fields`)
    },
    async getTenantContentTypes(){
        return await Http.get(`/content/tenantContentTypes`)
    },
    async updateTenantContentType(data){
        return await Http.patch(`/content/tenantContentType`, data)
    },
    async getEditorials(limit = 1000,active = 'all') {
        return await Http.get(`/content/editorials?limit=${limit}&active=${active}`)
    },
    async deleteEditorials(id) {
        return await Http.delete(`/content/editorials/${id}`)
    },
    async addEditorials(data) {
        return await Http.post(`/content/editorials`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async editEditorial(id, data){
        return await Http.post(`/content/editorials/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
}


